<script>
import Url from "../../tools/url.js";
import InFormImportHistory from "../../containers/InForm/ImportHistory.vue";

export default {
    components: {
        "in-form-import-history": InFormImportHistory,
    },
    props: {
        initTab: {
            type: Number,
            default: 0,
        },
        initSearch: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            selectedTab: this.initTab,
            search: this.initSearch,
        };
    },
    methods: {
        performSearch() {
            let url = new Url(window.location.href);
            url.setQueryParameter("tab", 1);
            url.setQueryParameter("search", this.search);

            window.location.href = url.buildUrl();
        },
    }
};
</script>
